import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { Check, Gift, Lock, CalendarCheck, ShoppingCart, ChefHat, ChevronDown, ClipboardList } from 'lucide-react';
export function ValueStack() {
  const [mainExpired, setMainExpired] = useState(false);
  const [showBonusDetails, setShowBonusDetails] = useState(false);
  // Check on mount if the 24h timer already expired
  useEffect(() => {
    const startTime = localStorage.getItem('nutripeques-countdown-start');
    if (startTime) {
      const endTime = parseInt(startTime, 10) + 24 * 60 * 60 * 1000;
      if (Date.now() >= endTime) {
        setMainExpired(true);
      }
    }
  }, []);
  const stackItems = [{
    name: '📘 Guía de Fundamentos',
    value: '$15 USD'
  }, {
    name: '🌞 Mañanas con Energía (16 desayunos)',
    value: '$8 USD'
  }, {
    name: '🍲 Platos que Nutren (22 comidas)',
    value: '$12 USD'
  }, {
    name: '🍎 Snacks Inteligentes (12 meriendas)',
    value: '$8 USD'
  }, {
    name: '🎉 Gustitos Conscientes (10 recetas)',
    value: '$6 USD'
  }, {
    name: '📋 Sistema NutriPeques planificación semanal',
    value: '$10 USD'
  }, {
    name: '📊 Tabla de respuestas para conflictos en mesa',
    value: '$5 USD'
  }, {
    name: '💡 Tips de congelación y reutilización',
    value: '$4 USD'
  }];
  const bonusDetails = [{
    number: 1,
    icon: CalendarCheck,
    iconColor: 'text-[#1565C0]',
    iconBg: 'bg-[#E3F2FD]',
    accentColor: 'border-[#1565C0]',
    badgeBg: 'bg-[#1565C0]',
    title: '"El Sistema Domingo en 20 Minutos"',
    value: '$17.00 USD',
    image: 'https://cdn.magicpatterns.com/uploads/8NKPSnJEB22KAkyZPYetiW/bonoplannerdomingo.png',
    intro: '¿Cuántas veces llegaste al lunes sin idea de qué cocinar? Este sistema te enseña a planificar 7 días completos de comidas en una sola sesión de 20 minutos los domingos.',
    features: ['El framework "4-2-1" para sumar variedad sin pelea', 'Planner semanal imprimible + versión editable', 'Plantilla de rotación de 4 semanas', 'Checklist de 20 minutos para pegar en la heladera', 'Plan B anti-rechazo para días caóticos']
  }, {
    number: 2,
    icon: ShoppingCart,
    iconColor: 'text-[#2E7D32]',
    iconBg: 'bg-[#E8F5E9]',
    accentColor: 'border-[#2E7D32]',
    badgeBg: 'bg-[#2E7D32]',
    title: '"Lista de Supermercado Anti-Ultraprocesados"',
    value: '$12.00 USD',
    image: 'https://cdn.magicpatterns.com/uploads/5QRfqf6mfdLnMEJ9QeBZmF/mocklistasuper.png',
    intro: 'El súper es el lugar donde se rompe todo. Esta lista te da una hoja de ruta por pasillos para entrar, comprar y salir en tiempo récord — con comida real.',
    features: ['Lista organizada pasillo por pasillo (súper argentino típico)', 'Guía de sustituciones: "si no hay X, comprá Y"', 'Mini-guía para leer etiquetas en 20 segundos', 'Plantilla por 3 niveles de presupuesto (Ajustado / Normal / Completo)', 'Lista de meriendas reales para no caer en paquetes', 'Versión móvil para llevar en el celu']
  }, {
    number: 3,
    icon: ChefHat,
    iconColor: 'text-[#6A1B9A]',
    iconBg: 'bg-[#F3E5F5]',
    accentColor: 'border-[#6A1B9A]',
    badgeBg: 'bg-[#6A1B9A]',
    title: '"Guía Mini-Chefs: Estrategia de Exposición"',
    value: '$18.00 USD',
    image: 'https://cdn.magicpatterns.com/uploads/q9dpGpwomS1FaZUPoTMJ9T/mockminichefs.png',
    intro: 'Si tu hijo rechaza todo lo nuevo, el problema no empieza en el plato. La Guía Mini-Chefs te enseña a usar micro-tareas de 3 minutos para que tu hijo se exponga a nuevos alimentos sin presión.',
    features: ['El Mapa de Progreso (mirar → tocar → oler → probar)', 'Tareas por edad (1–2 / 3–4 / 5–7 años)', 'Scripts exactos para invitar sin presión y responder al "NO"', 'Plan de exposición de 7 días + tabla de seguimiento', '12 "Misiones Mini-Chefs" listas para usar', 'Checklist imprimible']
  }];
  const bonusStackItems = [{
    icon: CalendarCheck,
    iconColor: 'text-[#1565C0]',
    iconBg: 'bg-[#E3F2FD]',
    name: 'Sistema Domingo en 20 Minutos',
    value: '$17.00 USD'
  }, {
    icon: ShoppingCart,
    iconColor: 'text-[#2E7D32]',
    iconBg: 'bg-[#E8F5E9]',
    name: 'Lista Anti-Ultraprocesados',
    value: '$12.00 USD'
  }, {
    icon: ChefHat,
    iconColor: 'text-[#6A1B9A]',
    iconBg: 'bg-[#F3E5F5]',
    name: 'Guía Mini-Chefs: Estrategia de Exposición',
    value: '$18.00 USD'
  }];
  return <section id="oferta" className="py-20 px-4 bg-gradient-to-b from-[#FFF8F0] to-[#FFE0B2]/50" data-id="element-462">
      <div className="max-w-lg md:max-w-3xl mx-auto" data-id="element-463">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-[2rem] shadow-2xl overflow-hidden border-4 border-[#FF8A65] relative" data-id="element-464">
          {/* Header */}
          <div className="bg-[#FF8A65] text-white text-center py-6 px-4" data-id="element-465">
            <h2 className="text-2xl md:text-3xl font-black tracking-wide" data-id="element-466">
              OFERTA ESPECIAL DE LANZAMIENTO
            </h2>
          </div>

          <div className="p-6 md:p-10" data-id="element-467">
            {/* Stack List */}
            <div className="space-y-3 mb-4" data-id="element-468">
              {stackItems.map((item, idx) => <div key={idx} className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-469">
                  <div className="flex items-center gap-2" data-id="element-470">
                    <Check className="w-5 h-5 text-[#4CAF50] shrink-0" data-id="element-471" />
                    <span className="text-gray-700 font-medium" data-id="element-472">
                      {item.name}
                    </span>
                  </div>
                  <span className="text-gray-400 line-through text-sm shrink-0 ml-4" data-id="element-473">
                    {item.value}
                  </span>
                </div>)}
              <div className="flex justify-between items-center bg-[#FFF3E0] p-3 rounded-xl border border-[#FFE0B2]" data-id="element-474">
                <div className="flex items-center gap-2" data-id="element-475">
                  <Gift className="w-5 h-5 text-[#E65100] shrink-0" data-id="element-476" />
                  <span className="text-[#E65100] font-bold" data-id="element-477">
                    Todas las actualizaciones futuras
                  </span>
                </div>
                <span className="text-[#E65100] font-black shrink-0 ml-4" data-id="element-478">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bonus items in stack */}
            <div className="mb-8" data-id="element-479">
              <div className="flex items-center gap-2 mb-3 mt-6" data-id="element-480">
                <Gift className="w-5 h-5 text-[#E65100]" data-id="element-481" />
                <span className="text-sm font-bold text-[#E65100] uppercase tracking-wider" data-id="element-482">
                  + 3 Bonos de regalo hoy
                </span>
              </div>
              <div className="space-y-2" data-id="element-483">
                {bonusStackItems.map((bonus, idx) => {
                const BonusIcon = bonus.icon;
                return <div key={idx} className="flex justify-between items-center bg-[#FFFDE7] p-3 rounded-xl border border-[#FFF9C4]" data-id="element-484">
                      <div className="flex items-center gap-2" data-id="element-485">
                        <div className={`${bonus.iconBg} p-1.5 rounded-lg`} data-id="element-486">
                          <BonusIcon className={`w-4 h-4 ${bonus.iconColor}`} data-id="element-487" />
                        </div>
                        <span className="text-gray-800 font-bold text-sm" data-id="element-488">
                          {bonus.name}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 shrink-0 ml-3" data-id="element-489">
                        <span className="text-gray-400 line-through text-xs" data-id="element-490">
                          {bonus.value}
                        </span>
                        <span className="bg-[#4CAF50] text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-491">
                          GRATIS
                        </span>
                      </div>
                    </div>;
              })}
              </div>

              {/* Leer más toggle */}
              <button onClick={() => setShowBonusDetails(!showBonusDetails)} className="mt-3 flex items-center gap-1.5 mx-auto text-[#E65100] font-bold text-sm hover:text-[#BF360C] transition-colors" data-id="element-492">
                {showBonusDetails ? 'Ver menos' : 'Leer más sobre los bonos'}
                <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${showBonusDetails ? 'rotate-180' : ''}`} data-id="element-493" />
              </button>

              {/* Expandable bonus details */}
              <AnimatePresence data-id="element-494">
                {showBonusDetails && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.4
              }} className="overflow-hidden" data-id="element-495">
                    <div className="mt-4 space-y-6" data-id="element-496">
                      {bonusDetails.map((bonus, idx) => {
                    const BonusDetailIcon = bonus.icon;
                    return <div key={idx} className={`bg-gray-50 rounded-2xl p-5 border-l-4 ${bonus.accentColor}`} data-id="element-497">
                            <div className="flex items-center gap-3 mb-3" data-id="element-498">
                              <div className={`${bonus.iconBg} p-2 rounded-xl`} data-id="element-499">
                                <BonusDetailIcon className={`w-5 h-5 ${bonus.iconColor}`} data-id="element-500" />
                              </div>
                              <div data-id="element-501">
                                <span className={`${bonus.badgeBg} text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider`} data-id="element-502">
                                  Bono #{bonus.number}
                                </span>
                                <h4 className="text-base font-black text-gray-900 mt-1" data-id="element-503">
                                  {bonus.title}
                                </h4>
                              </div>
                            </div>

                            <div className="flex justify-center mb-4" data-id="element-504">
                              <img src={bonus.image} alt={bonus.title} className="w-full max-w-[200px] h-auto rounded-xl shadow-sm" data-id="element-505" />
                            </div>

                            <p className="text-gray-600 text-sm mb-4 leading-relaxed" data-id="element-506">
                              {bonus.intro}
                            </p>

                            <div className="space-y-2" data-id="element-507">
                              <p className="text-xs font-bold text-gray-900 flex items-center gap-1.5" data-id="element-508">
                                <ClipboardList className="w-3.5 h-3.5 text-gray-500" data-id="element-509" />
                                Incluye:
                              </p>
                              <ul className="space-y-1.5" data-id="element-510">
                                {bonus.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-2 text-sm" data-id="element-511">
                                    <Check className="w-4 h-4 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-512" />
                                    <span className="text-gray-700" data-id="element-513">
                                      {feature}
                                    </span>
                                  </li>)}
                              </ul>
                            </div>

                            <p className="text-center text-sm font-bold text-gray-900 mt-4" data-id="element-514">
                              Valor:{' '}
                              <span className="line-through text-gray-400" data-id="element-515">
                                {bonus.value}
                              </span>{' '}
                              <span className="text-[#4CAF50]" data-id="element-516">GRATIS hoy</span>
                            </p>
                          </div>;
                  })}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>

            {/* Pricing Area */}
            <div className="bg-[#FDFBF7] rounded-2xl p-6 md:p-8 text-center border border-gray-200 mb-8 relative overflow-hidden" data-id="element-517">
              <div className="absolute top-0 right-0 bg-[#E65100] text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-518">
                {mainExpired ? '62% DE DESCUENTO' : '84% DE DESCUENTO'}
              </div>

              <div className="mb-2" data-id="element-519">
                <span className="text-gray-500 font-medium" data-id="element-520">Valor total: </span>
                <span className="text-gray-400 line-through text-lg" data-id="element-521">
                  $93 USD
                </span>
              </div>

              <div className="mb-4" data-id="element-522">
                <span className="text-gray-600 font-bold" data-id="element-523">
                  Precio regular:{' '}
                </span>
                <span className="text-gray-500 line-through text-xl" data-id="element-524">
                  $39 USD
                </span>
              </div>

              {!mainExpired ? <div className="text-center mb-2" data-id="element-525">
                  <span className="block text-sm font-bold text-[#4CAF50] uppercase tracking-wider mb-1" data-id="element-526">
                    Oportunidad Única de Lanzamiento
                  </span>
                  <div className="flex justify-center items-start gap-1" data-id="element-527">
                    <span className="text-3xl font-bold text-[#2E7D32] mt-2" data-id="element-528">
                      $
                    </span>
                    <span className="text-7xl md:text-8xl font-black text-[#2E7D32] leading-none" data-id="element-529">
                      6.39
                    </span>
                    <span className="text-xl font-bold text-[#2E7D32] mt-2" data-id="element-530">
                      USD
                    </span>
                  </div>
                </div> : <div className="text-center mb-2" data-id="element-531">
                  <span className="block text-sm font-bold text-[#E65100] uppercase tracking-wider mb-1" data-id="element-532">
                    Precio especial por tiempo limitado
                  </span>
                  <div className="flex justify-center items-start gap-1" data-id="element-533">
                    <span className="text-3xl font-bold text-[#E65100] mt-2" data-id="element-534">
                      $
                    </span>
                    <span className="text-7xl md:text-8xl font-black text-[#E65100] leading-none" data-id="element-535">
                      14.99
                    </span>
                    <span className="text-xl font-bold text-[#E65100] mt-2" data-id="element-536">
                      USD
                    </span>
                  </div>
                </div>}
            </div>

            {/* Urgency — 24h countdown only when not expired */}
            {!mainExpired && <div className="text-center mb-8" data-id="element-537">
                <p className="text-[#D84315] font-bold mb-2" data-id="element-538">
                  ⏰ Esta oferta desaparece en:
                </p>
                <CountdownTimer hours={24} storageKey="nutripeques-countdown-start" onExpire={() => setMainExpired(true)} data-id="element-539" />
                <p className="text-gray-500 text-sm mt-2" data-id="element-540">
                  Después el precio sube a $39 USD
                </p>
              </div>}

            {/* CTA — changes based on expired state */}
            <div className="flex flex-col items-center" data-id="element-541">
              {!mainExpired ? <>
                  <a href="https://pay.hotmart.com/T104716980E?off=3x8vd7e9&checkoutMode=10" className="w-full min-h-[72px] bg-[#4CAF50] hover:bg-[#388E3C] text-white text-xl md:text-2xl font-black rounded-2xl shadow-[0_8px_0_#2E7D32] hover:shadow-[0_4px_0_#2E7D32] hover:translate-y-1 transition-all flex items-center justify-center text-center px-4 py-4 mb-4" data-id="element-542">
                    → QUIERO EMPEZAR A NUTRIR CON CALMA
                  </a>
                  <p className="text-sm text-gray-500 font-medium flex flex-wrap justify-center gap-2 text-center" data-id="element-543">
                    <span data-id="element-544">Acceso inmediato</span>
                    <span className="hidden sm:inline" data-id="element-545">·</span>
                    <span data-id="element-546">Descarga directa</span>
                    <span className="hidden sm:inline" data-id="element-547">·</span>
                    <span data-id="element-548">Garantía total</span>
                  </p>
                </> : <>
                  <a href="https://pay.hotmart.com/T104716980E?off=e1tj7u2p&checkoutMode=10" className="w-full min-h-[72px] bg-[#4CAF50] hover:bg-[#388E3C] text-white text-xl md:text-2xl font-black rounded-2xl shadow-[0_8px_0_#2E7D32] hover:shadow-[0_4px_0_#2E7D32] hover:translate-y-1 transition-all flex items-center justify-center text-center px-4 py-4 mb-4" data-id="element-549">
                    SÍ, QUIERO NUTRIPEQUES
                  </a>
                  <p className="text-sm text-gray-500 font-medium flex items-center justify-center gap-2 text-center" data-id="element-550">
                    <Lock className="w-4 h-4" data-id="element-551" />
                    <span data-id="element-552">
                      Pago seguro · Acceso inmediato · Garantía 7 días
                    </span>
                  </p>
                </>}
            </div>
          </div>
        </motion.div>

        <p className="text-center text-gray-600 italic mt-8 text-lg" data-id="element-553">
          "No necesitas hacerlo perfecto. Necesitas empezar."
        </p>
      </div>
    </section>;
}